<mat-select [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareWith"
  (selectionChange)="onSelectionChange()" [matTooltip]="'OPPORTUNITY.PLEASE_SELECT_SERVICE' | translate"
  [matTooltipDisabled]="disableTooltip || !!serviceId" [placeholder]="'GENERAL.UNIT' | translate">
  <ng-container *ngIf="this.serviceUnits">
    <mat-option *ngFor="let serviceUnit of serviceUnits" [value]="serviceUnit">{{serviceUnit.name}}</mat-option>
  </ng-container>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>